import { useExternalContextsStore } from '../attachtment-store';

export const useConversationExternalAttachments = (key: string) => {
	const [externalContexts, { addExternalContext }] = useExternalContextsStore(key);

	const externalContextsServiceRepresentations = externalContexts.map(
		(context) => context.serviceRepresentation,
	);

	return { addExternalContext, externalContextsServiceRepresentations };
};
